<p-toast></p-toast>
<p-menubar [model]="items"><ng-container *ngIf="auth.isAuthenticated$ | async; else loggedOut">
    <p-button (click)="auth.logout({ logoutParams: { returnTo: document.location.origin } })" label="Log out"></p-button>
  </ng-container>

  <ng-template #loggedOut>
    <p-button (click)="auth.loginWithRedirect()" label="Log in"></p-button>
  </ng-template>
</p-menubar>
<router-outlet></router-outlet>